import styled from 'styled-components'

import theme from 'theme_'

import { WhiteBlock } from 'components/Layout'
import Icon from '@mdi/react'

export const StyledUpdateSubscriptionWrapper = styled.div`
  width: 100%;
`

export const StyledPaymentMethods = styled(WhiteBlock)`
  padding-bottom: ${theme.spacing.base};
`

export const StyledCardsBlock = styled.div`
  margin-bottom: ${theme.spacing.base};
`
export const MigrateSuccessIcon = styled(Icon)`
  color: ${theme.colors.success};
`

export const MigrateErrorIcon = styled(Icon)`
  color: ${theme.colors.error};
`
